/**
 * @fileoverview Input/output schemas for the character-extractor-full-v2 agent.
 *
 * This agent reads a document and extracts a comprehensive list of all characters
 * with detailed attributes.
 */

import { z } from 'zod';
import { BaseFlowInputSchema } from '@/ai/agents/base-schema';
import { CharacterV2IdeaSchema } from '@/domains/characters/schemas';

// =============================================================================
// FLOW INPUT SCHEMA
// =============================================================================

export const InputSchema = BaseFlowInputSchema.extend({
  textInput: z.string().describe('The full text content of the document to analyze.'),
});

export type Input = z.infer<typeof InputSchema>;

// =============================================================================
// OUTPUT SCHEMA
// =============================================================================

export const OutputSchema = z.object({
  characters: z.array(CharacterV2IdeaSchema).describe('An array of all characters extracted from the document.'),
});

export type Output = z.infer<typeof OutputSchema>;
